import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoggerStore } from './logger.store';
import { filter, take } from 'rxjs/operators';

const I2G_DEBUG_MODE_PARAM = 'I2G_DEBUG_MODE';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  private _debugMode: boolean;

  constructor(
    private _route: ActivatedRoute,
    private _loggerStore: LoggerStore
  ) {
    this._route.queryParamMap
      .pipe(
        filter(
          (queryParamMap) => queryParamMap.get(I2G_DEBUG_MODE_PARAM) !== null
        ),
        take(1)
      )
      .subscribe(() => (this._debugMode = true));
  }

  init(debugMode: boolean) {
    this._debugMode = debugMode;
  }

  log(...messageParts) {
    if (this._debugMode) {
      console.log.apply(console, messageParts);
    }

    this._loggerStore.pushLog([Date.now(), messageParts]);
  }

  debug(...messageParts) {
    if (this._debugMode) {
      console.debug.apply(console, messageParts);
    }
  }

  logError(error: any) {
    if (error instanceof Error) {
      this.log(error.name, error.message);
    } else {
      this.log(error);
    }
  }
}
